import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/country.mapper";
import * as i2 from "../data.requirements";
export class GetCountryListUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run() {
        return this.data.getCountryList().pipe(this.mapper.map);
    }
}
GetCountryListUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetCountryListUseCase_Factory() { return new GetCountryListUseCase(i0.ɵɵinject(i1.CountryMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: GetCountryListUseCase, providedIn: "root" });
